<template>
    <v-card class='mt-2'>
                <div class='d-flex flex-no-wrap justify-space-between'>
                      <v-avatar tile size=150>
                        <v-img :src='productImg'></v-img>
                      </v-avatar>
                      <v-card-text class='pt-1 pb-1'>
                          <v-row align='center' justify='end'>
                              
                                <v-icon @click="removeProduct"> mdi-close</v-icon>
                          </v-row>
                          <v-card-title class='pt-1 pb-2'>{{productName}}</v-card-title>
                         
                         <v-card-subtitle class='pb-1'>Price: {{productPrice}}</v-card-subtitle>
                         <v-card-text class='pl-7 pb-0'>
                            <v-row align='center'>
                            <p class='mr-3'>Quantity</p>
                            <div style='width:100px;'>
                                <v-select
                                  dense
                                  class='qty_wrapper mb-0' 
                                  :items="items"
                                  v-model="qty"
                                  max-width='150'
                                  solo
                                  @change="qtyChange"
                                ></v-select>
                            </div>
                         
                           </v-row>
                          
                        </v-card-text>
                       
                    </v-card-text>
                </div> 
    </v-card>
</template>
<script>
export default {
    name:'CartEntry',
    props:['productId','productName','productPrice','qty','productImg'],
    data(){
        return{
            items:[1,2,3]
        }
    },
    methods:{
        qtyChange(){
            this.$emit('onQtyChange',{
                id : this.productId,
                qty : this.qty
            })
        },
        removeProduct(){
            this.$emit('onProductRemove',this.productId)
        }
    }
}
</script>
